// export const domain = (process.env.NODE_ENV === 'development' ? 'https://yjdev.xkw.com' : location.origin) + '/api'
export const domain = location.origin + '/api'



// WEBPACK FOOTER //
// ./src/config.js